import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../utils/api";
import ReleaseModal from "../components/ReleaseModal";

export default function ShortLinkRedirect() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [release, setRelease] = useState(null);

  useEffect(() => {
    api.get(`/shortlinks/${slug}`)
      .then((res) => {
        return api.get(`/releases/${res.data.release_id}`);
      })
      .then((res) => setRelease(res.data))
      .catch(() => navigate("/", { replace: true }));
  }, [slug, navigate]);

  if (!release) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-rose-600 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505]">
      <ReleaseModal release={release} onClose={() => navigate("/", { replace: true })} />
    </div>
  );
}
